import React, { useState, useEffect } from "react";
import DropdownRight from "./DropdownRight";
import AppNav from "./Nav";
import arrowleft from "../assets/images/arrow-left.png";
import dots from "../assets/images/dots.svg";
import Modal from "react-bootstrap/Modal";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Tab, Nav } from "react-bootstrap";
import http from "../services/http";
import GetStorage from "../services/Storage";
import moment from "moment";
import { showToast } from "./ShowToast";
import polygon from "../assets/images/Polygon 56.png";
import Dropdown from "react-bootstrap/Dropdown";
import { SpinnerCircular } from "spinners-react";
import ReactPaginate from "react-paginate";
import ReactStars from "react-rating-stars-component";
import { AiFillEye } from "react-icons/ai";


function AnalystsIntermediate(props) {
  const [showModal, setShow] = useState(false);
  const [showRatingModal, setShowTatingModal] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleRatingModalClose = () => setShowTatingModal(false);
  const handleRatingModalShow = () => setShowTatingModal(true);
  const [key, setKey] = useState("progress");
  const token = GetStorage.get("xAuthToken");
  const [inprogress, setInprogress] = useState([]);
  const [complete, setComplete] = useState([]);
  const location = useLocation();
  const { id, name, isdeactivate } = location.state;
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [uploadSpin, setUploadSpin] = useState(false);
  const [ratingDetails, setRatingDetails] = useState(null);


  useEffect(() => {
    TeamShark();
  }, []);

  const TeamShark = async () => {
    http
      .get(`public/admin/analyst/orders/${id}?status=Inprogress&token=${token}`)
      .then((res) => {
        console.log("reponse", res.data);
        setInprogress(res.data);
      })
      .catch((error) => {});
  };

  const InProgress = (k) => {
    setKey(k);
    switch (k) {
      case "teamInfo":
        setLoading(true);

        http
          .get(
            `public/admin/analyst/orders/${id}?status=Inprogress&token=${token}`
          )

          .then((res) => {
            setInprogress(res.data);
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
          });
        break;

      default:
        setLoading(true);

        http
          .get(
            `public/admin/analyst/orders/${id}?status=completed&token=${token}`
          )
          .then((res) => {
            console.log("completed", res.data);
            setComplete(res.data);
            setLoading(false);
          })
          .catch((error) => {
            console.log(error);
            setLoading(false);
          });
        break;
    }
  };

  const deactivateAnalyst = async () => {
    setUploadSpin(true);
    if (isdeactivate === 0) {
      http
        .put(`public/admin/analyst/deactivate/${id}?token=${token}`)
        .then((res) => {
          console.log("deactvate", res.data.message);

          handleClose();
          showToast("success", res.data.message);
          setTimeout(() => {
            navigate("/analystsCheckBox");
          }, 1000);
        })
        .catch((error) => {
          console.log("error ", error.response);

          if (error.response) {
            if (error.response.data.errors) {
              for (let key in error.response.data.errors) {
                setError(error.response.data.errors[key]);
                showToast("error", error.response.data.errors[key]);
                handleClose();
              }
            } else if (error.response.data.message) {
              showToast("error", error.response.data.message);
              handleClose();
              setError(error.response.data.message);
            }
          }
        });
    } else {
      http
        .put(`public/admin/analyst/activate/${id}?token=${token}`)
        .then((res) => {
          console.log("deactvate", res.data.message);

          handleClose();
          showToast("success", res.data.message);
          setTimeout(() => {
            navigate("/analystsCheckBox");
          }, 1000);
        })
        .catch((error) => {
          console.log("error ", error.response);

          if (error.response) {
            if (error.response.data.errors) {
              for (let key in error.response.data.errors) {
                setError(error.response.data.errors[key]);
                showToast("error", error.response.data.errors[key]);
                handleClose();
              }
            } else if (error.response.data.message) {
              showToast("error", error.response.data.message);
              handleClose();
              setError(error.response.data.message);
            }
          }
        });
    }
  };

  const WatchVideoCode = async (id, type) => {
    setLoading(true);

    http
      .get(`api/common/video_request?token=${token}`)
      .then((res) => {
        console.log("response ------->>>>", res.data);

        navigate(`/otpLogs/${id}/${type}`);

        // setLocker(res.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);

        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };

  const WatchVideoCopleted = async (id, type) => {
    setLoading(true);

    http
      .get(`api/common/video_request?token=${token}`)
      .then((res) => {
        console.log("response ------->>>>", res.data);

        navigate(`/otpLogs/${id}/${type}`);

        // setLocker(res.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);

        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };

  const [pageNumber, setPageNumber] = useState(0);
  const usersPerPage = 7;
  const pagesVisited = pageNumber * usersPerPage;
  const pageCountProgress = Math.ceil(inprogress.length / usersPerPage);
  const pageCountComplete = Math.ceil(complete.length / usersPerPage);

  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  return (
    <>
      <body>
        <div class="wrapper">
          <AppNav />
          <div id="content">
            <header>
              <div className="dashboard_header">
                <div className="left-side d-flex ">
                  {" "}
                  <button
                    onClick={() => navigate("/analystsCheckBox")}
                    type="button"
                    className="btn btn-link  "
                  >
                    {" "}
                    <img src={arrowleft} className="img-fluid" />{" "}
                  </button>
                  <h1>Analyst: {name}</h1>
                </div>
                <DropdownRight />
              </div>
            </header>
            <div class="dashbord_content">
              <div class="analysts-wraper-head">
                <div class="personal_and_bank_info Analysts_tabs Intermediate">
                  <Tab.Container id="left-tabs-example" defaultActiveKey={key}>
                    <div className="analysts-wraper-head">
                      <div className="personal_and_bank_info Analysts_tabs">
                        <Nav
                          style={{
                            backgroundColor: "#e3e3e3",
                            borderRadius: 5,
                          }}
                          activeKey={key}
                          onSelect={(k) => InProgress(k)}
                          className="nav nav-pills border-bottom-0"
                          defaultActiveKey="progress"
                        >
                          <Nav.Item>
                            <Nav.Link eventKey="progress">In Progress</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link eventKey="completed">Completed</Nav.Link>
                          </Nav.Item>
                        </Nav>
                      </div>
                      <div className="map_btn">
                        <button
                          onClick={handleShow}
                          className="them_btn"
                          type="button"
                          data-toggle="modal"
                          data-target="#Are_you_sure"
                        >
                          {isdeactivate === 1 ? "Activate" : "Deactivate"}{" "}
                          Analyst
                        </button>{" "}
                      </div>
                    </div>
                    <Tab.Content style={{ marginTop: 30 }}>
                      <Tab.Pane eventKey="progress">
                        <div class="tab-content" id="pills-tabContent">
                          <div
                            class="tab-pane fade show active"
                            id="pills-All"
                            role="tabpanel"
                            aria-labelledby="pills-All-tab"
                          >
                            <div class="table_vedio_upload dashbord_table     mb_30 over_flow mb-0">
                              <table class="table table-borderless table-responsive-lg">
                                <thead>
                                  <tr>
                                    <th scope="col" class=" w_150 pl_25">
                                      Video
                                    </th>
                                    {/* <th scope="col" class="w_556 ">
                                      Title
                                    </th> */}
                                    <th scope="col" class=" w_150">
                                      Stroke
                                    </th>
                                    <th scope="col" class=" w_150">
                                      Duration
                                    </th>
                                    <th scope="col" class=" w_150">
                                      Date
                                    </th>
                                    <th scope="col" class=" w_150 ">
                                      {" "}
                                    </th>
                                  </tr>
                                </thead>
                                {loading ? (
                                  <div
                                    style={{
                                      width: "100%",
                                      position: "absolute",
                                      display: "flex",
                                      justifyContent: "center",
                                      marginTop: 40,
                                      backgroundColor: "#ffffffc2",
                                    }}
                                  >
                                    <SpinnerCircular size="7%" />
                                  </div>
                                ) : (
                                  <tbody>
                                    {inprogress?.map((item) => (
                                      <tr>
                                        <td>
                                          <Link
                                            style={{
                                              position: "relative",
                                            }}
                                            to="/video"
                                            state={{
                                              id:item.recording_id,
                                              name: item.firstCameraOutput,
                                            }}
                                          >
                                            <video width={100} height={70}>
                                              <source
                                                src={item.firstCameraOutput}
                                              />
                                            </video>
                                            <img
                                              src={polygon}
                                              alt=""
                                              style={{
                                                position: "absolute",
                                                marginTop: 25,
                                                marginLeft: -60,
                                                width: 20,
                                                height: 20,
                                              }}
                                            />
                                          </Link>
                                        </td>
                                        {/* <td>
                                          {item.analystFirstName +
                                            item.analystLastName +
                                            item.teamName +
                                            item.stroke +
                                            item.created_at}
                                        </td> */}
                                        <td>{item.stroke}</td>
                                        <td>{parseFloat(item.duration).toFixed(2)}</td>
                                        <td>
                                          {moment(item.created_at).format(
                                            "MMM Do YY"
                                          )}
                                        </td>
                                        <td>
                                          <div className="dropdown wraper_btn">
                                            <Dropdown>
                                              <Dropdown.Toggle
                                                // className="btn dropdown-toggle"
                                                variant="success"
                                                id="dropdown-basic"
                                              >
                                                <img
                                                  src={dots}
                                                  className="img-fulid"
                                                  alt="dropdown"
                                                />
                                              </Dropdown.Toggle>

                                              <Dropdown.Menu
                                                as="ul"
                                                className="dropul"
                                              >
                                                <Dropdown.Item
                                                  to="#/action-1"
                                                  as="li"
                                                  onClick={() =>
                                                    WatchVideoCode(
                                                      item.id,
                                                      "order_pending"
                                                    )
                                                  }
                                                >
                                                  Show video
                                                </Dropdown.Item>
                                              </Dropdown.Menu>
                                            </Dropdown>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                )}
                              </table>
                              <div className="pagination">
                                <div className="paginateText">
                                  <p className="text-table-show">
                                    {" "}
                                    Showing{" "}
                                    {
                                      inprogress.slice(
                                        pagesVisited,
                                        pagesVisited + usersPerPage
                                      ).length
                                    }{" "}
                                    out of {inprogress.length} entries
                                  </p>
                                </div>
                                <div
                                  className="reactPaginate"
                                  style={{
                                    overflowX: "hidden",
                                    paddingTop: "10px",
                                  }}
                                >
                                  <ReactPaginate
                                    previousLabel={"<<"}
                                    nextLabel={">>"}
                                    pageCount={pageCountProgress}
                                    onPageChange={changePage}
                                    containerClassName={"paginationBttns"}
                                    previousLinkClassName={"previousBttn"}
                                    nextLinkClassName={"nextBttn"}
                                    disabledClassName={"paginationDisabled"}
                                    activeClassName={"paginationActive"}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="completed">
                        <div class="tab-content" id="pills-tabContent">
                          <div
                            class="tab-pane fade show active"
                            id="pills-All"
                            role="tabpanel"
                            aria-labelledby="pills-All-tab"
                          >
                            <div class="table_vedio_upload dashbord_table     mb_30 over_flow mb-0">
                              <table class="table table-borderless table-responsive-lg">
                                <thead>
                                  <tr>
                                    <th scope="col" class=" w_150 pl_25">
                                      Video
                                    </th>
                                    {/* <th scope="col" class="w_556 ">
                                      Title
                                    </th> */}
                                    <th scope="col" class=" w_150">
                                      Stroke
                                    </th>
                                    <th scope="col" class=" w_150">
                                      Duration
                                    </th>
                                    <th scope="col" class=" w_150">
                                      Date
                                    </th>
                                    <th scope="col" class="text-center w_150">
                                      Reviews
                                    </th>
                                    <th scope="col" class=" w_150 ">
                                      {" "}
                                    </th>
                                  </tr>
                                </thead>
                                {loading ? (
                                  <div
                                    style={{
                                      width: "100%",
                                      position: "absolute",
                                      display: "flex",
                                      justifyContent: "center",
                                      marginTop: 40,
                                      backgroundColor: "#ffffffc2",
                                    }}
                                  >
                                    <SpinnerCircular size="7%" />
                                  </div>
                                ) : (
                                  <tbody>
                                    {complete?.map((item) => (
                                      <tr>
                                        <td>
                                          <Link
                                            style={{
                                              position: "relative",
                                            }}
                                            to="/video"
                                            state={{
                                              id:item.recording_id,
                                              name: item.firstCameraOutput,
                                            }}
                                          >
                                            <video width={100} height={70}>
                                              <source
                                                src={item.firstCameraOutput}
                                              />
                                            </video>
                                            <img
                                              src={polygon}
                                              alt=""
                                              style={{
                                                position: "absolute",
                                                marginTop: 25,
                                                marginLeft: -60,
                                                width: 20,
                                                height: 20,
                                              }}
                                            />
                                          </Link>
                                        </td>
                                        {/* <td>
                                          {item.analystFirstName +
                                            item.analystLastName +
                                            item.teamName +
                                            item.stroke +
                                            item.created_at}
                                        </td> */}
                                        <td>{item.stroke}</td>
                                        <td>{parseFloat(item.duration).toFixed(2)}</td>
                                        <td>
                                          {moment(item.created_at).format(
                                            "MMM Do YY"
                                          )}
                                        </td>
                                        <td className="text-center">
                                        <button
                                          className="btn"
                                          // onClick={handleRatingModalShow}
                                          onClick={() => {setRatingDetails(item);setShowTatingModal(true)}}
                                          style={{
                                            background: 'none',    
                                            border: 'none',       
                                            cursor: 'pointer',   
                                            padding: 0        
                                          }}
                                        >
                                          <AiFillEye style={{ marginRight: '5px',fontSize: '24px' }} />
                                        </button>
                                        </td>
                                        <td>
                                          <div className="dropdown wraper_btn">
                                            <Dropdown>
                                              <Dropdown.Toggle
                                                // className="btn dropdown-toggle"
                                                variant="success"
                                                id="dropdown-basic"
                                              >
                                                <img
                                                  src={dots}
                                                  className="img-fulid"
                                                  alt="dropdown"
                                                />
                                              </Dropdown.Toggle>

                                              <Dropdown.Menu
                                                as="ul"
                                                className="dropul"
                                              >
                                                <Dropdown.Item
                                                as="li"
                                                onClick={() =>
                                                  WatchVideoCopleted(
                                                    item.id,
                                                    "evo"
                                                  )
                                                }
                                              >
                                                  Show video
                                                </Dropdown.Item>
                                              </Dropdown.Menu>
                                            </Dropdown>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                )}
                              </table>
                              <div className="pagination">
                                <div className="paginateText">
                                  <p className="text-table-show">
                                    {" "}
                                    Showing{" "}
                                    {
                                      complete.slice(
                                        pagesVisited,
                                        pagesVisited + usersPerPage
                                      ).length
                                    }{" "}
                                    out of {complete.length} entries
                                  </p>
                                </div>
                                <div
                                  className="reactPaginate"
                                  style={{
                                    overflowX: "hidden",
                                    paddingTop: "10px",
                                  }}
                                >
                                  <ReactPaginate
                                    previousLabel={"<<"}
                                    nextLabel={">>"}
                                    pageCount={pageCountComplete}
                                    onPageChange={changePage}
                                    containerClassName={"paginationBttns"}
                                    previousLinkClassName={"previousBttn"}
                                    nextLinkClassName={"nextBttn"}
                                    disabledClassName={"paginationDisabled"}
                                    activeClassName={"paginationActive"}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="modal fade starrating"
          id="Are_you_sure"
          data-backdrop="static"
          data-keyboard="false"
          tabindex="-1"
          aria-labelledby="Are_you_sure"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="Are_you_sure">
                  Are you sure?z
                </h5>{" "}
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  {" "}
                  <span aria-hidden="true">&times;</span>{" "}
                </button>
              </div>
              <div class="modal-body">
                <div class="raing_star">
                  <p>
                    Are you sure you want to invite these analyst(s) for meeting
                    call.{" "}
                  </p>
                </div>
                <div class="modal-footer border-top-0">
                  {" "}
                  <button type="button" class="them_btn_ouline ">
                    No
                  </button>{" "}
                  <button type="button" class="them_btn ">
                    Yes
                  </button>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="modal fade starrating"
          id="Google_Meet"
          data-backdrop="static"
          data-keyboard="false"
          tabindex="-1"
          aria-labelledby="Google_Meet"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="Google_Meet">
                  Google Meet
                </h5>{" "}
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  {" "}
                  <span aria-hidden="true">&times;</span>{" "}
                </button>
              </div>
              <div class="modal-body">
                <div class="raing_star">
                  {/*   <p>
                    Lorem ipsum dolor sit amet, consectetur adiet cing elit. nun
                    c non risus condiment lobortittyr at, ef sollicitudin risus.{" "}
                  </p> */}
                  <div
                    class="form-group icon mt-3 w-100"

                    // style="width:100%"
                  >
                    {" "}
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Wefdhbwexn9wduj3wjskd932"
                    />
                    <div class="img_icon">
                      <a href="">
                        <img src="assets/images/copy.svg" alt="" />{" "}
                      </a>
                    </div>
                  </div>
                </div>
                <div class="modal-footer border-top-0">
                  {" "}
                  <button type="button" class="them_btn_ouline ">
                    Send to all
                  </button>{" "}
                  <button type="button" class="them_btn ">
                    Select analysts
                  </button>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>

      <Modal className="starrating" show={showModal} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title as="h5">Are you sure?</Modal.Title>
          <button
            onClick={handleClose}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            {" "}
            <span aria-hidden="true">&times;</span>{" "}
          </button>
        </Modal.Header>
        <Modal.Body>
          <div class="raing_star">
            <p>Are you sure you want to perform this action?.</p>
          </div>
          <div className="modal-footer border-top-0">
            <button
              onClick={handleClose}
              type="button"
              className=" them_btn_ouline  "
            >
              Cancel
            </button>
            <button
              onClick={deactivateAnalyst}
              type="button"
              className="them_btn1 "
              data-toggle="modal"
              data-target="#new_team_add_yes"
            >
              {uploadSpin ? <SpinnerCircular /> : " YES"}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal className="starrating" show={showRatingModal} onHide={handleRatingModalClose}>
        <Modal.Header>
          <Modal.Title as="h5">eVO Feedback</Modal.Title>
          <button
            onClick={handleRatingModalClose}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            {" "}
            <span aria-hidden="true">&times;</span>{" "}
          </button>
        </Modal.Header>
        <Modal.Body>
        <div className="parent-name">
          <p>Parent Name: <strong>{ratingDetails?.parentFirstname + ' '+ratingDetails?.parentLastname} ({ratingDetails?.parentEmail}) </strong></p>
        </div>
          <div className="raing_star">
            <p>Service up to mark</p>
            <div className="rates" style={{ marginLeft: 318 }}>
              <ReactStars
                count={5}
                size={30}
                activeColor="#ffd700"
                value={ratingDetails?.service_stars}
                edit={false}
              />
            </div>
          </div>
          <div className="raing_star">
            <p>Recommend us</p>
            <div className="rates" style={{ marginLeft: 318 }}>
              <ReactStars
                count={5}
                size={30}
                activeColor="#ffd700"
                value={ratingDetails?.recommendus_stars}
                edit={false}
              />
            </div>
          </div>
          <div className="raing_star">
            <p>How helpful was this</p>
            <div className="rates" style={{ marginLeft: 318 }}>
              <ReactStars
                count={5}
                size={30}
                activeColor="#ffd700"
                value={ratingDetails?.helfpul_stars}
                edit={false}
              />
            </div>
          </div>

          <div class="form-group custom_text_area">
            <textarea
              class="form-control"
              rows="5"
              style={{ height: 150 }}
              value={ratingDetails?.comment}
            ></textarea>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default AnalystsIntermediate;
